import {Modal, Form} from "react-bootstrap";

const ShowAllImgModal = (props) => {
    /**
     * @function handleClose
     * @params
     * @description used to close modal
     */
    const handleClose = () => {
        props.handleClose();
    };

    return (
        <Modal show={props.show} onHide={handleClose}>
            <Modal.Header className="" closeButton />
            <Modal.Body className="auth-modal d-flex flex-column pt-0">
                <Form className="w-100">
                    {props?.individualData?.images?.length > 0 &&
                        props?.individualData?.images?.map((item, index) => (
                            <img
                                src={item}
                                alt="SingleComplexImg"
                                className="w-100 object-fit-scale single-page-banner-height-30vh my-3"
                                key={index}
                            />
                        ))}
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default ShowAllImgModal;
